/* Image-first YouTube backdrop; load only after page load, while visible and allowed. */
(function () {
    const figure = document.querySelector('[data-studio-trailer]');
    if (!figure || !('IntersectionObserver' in window)) return;
    let url;
    try { url = new URL(figure.dataset.studioTrailer); } catch (error) { return; }
    if (url.protocol !== 'https:') return;
    let id;
    if (url.hostname === 'youtu.be') id = url.pathname.slice(1);
    if (['www.youtube.com', 'youtube.com'].includes(url.hostname)) id = url.searchParams.get('v');
    if (!id || !/^[\w-]{11}$/.test(id)) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let visible = false, loaded = false, started = false, ready = false, failed = false, player;
    function allowed() {
        return visible && loaded && !failed && !document.hidden && !reduced.matches &&
            !(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType))) &&
            !document.documentElement.classList.contains('studio-motion-paused');
    }
    function fallback() { figure.classList.remove('is-trailer-playing'); }
    function fail() {
        failed = true;
        fallback();
        if (player && player.destroy) player.destroy();
    }
    function sync() {
        if (!allowed()) {
            fallback();
            if (ready) player.pauseVideo();
            return;
        }
        if (ready) { player.mute(); player.playVideo(); }
        else if (!started) { started = true; loadAPI(); }
    }
    function create() {
        if (failed) return;
        // A preference may have changed while the API was downloading.
        if (!allowed()) { started = false; return; }
        const surface = document.createElement('span');
        surface.className = 'studio-trailer-surface';
        surface.setAttribute('aria-hidden', 'true');
        const mount = document.createElement('span');
        surface.append(mount);
        figure.append(surface);
        player = new window.YT.Player(mount, {
            host: 'https://www.youtube-nocookie.com',
            videoId: id,
            playerVars: {autoplay: 0, controls: 0, disablekb: 1, playsinline: 1,
                loop: 1, playlist: id, rel: 0, origin: location.origin},
            events: {
                onReady: event => {
                    ready = true;
                    const frame = event.target.getIframe();
                    frame.tabIndex = -1;
                    frame.setAttribute('aria-hidden', 'true');
                    frame.title = 'Muted gameplay preview';
                    event.target.mute();
                    sync();
                },
                onStateChange: event => {
                    if (event.data === 1 && allowed()) figure.classList.add('is-trailer-playing');
                    else if (event.data !== 3) fallback();
                    if (event.data === 1 && !allowed()) player.pauseVideo();
                },
                onAutoplayBlocked: fallback,
                onError: fail
            }
        });
    }
    function loadAPI() {
        if (window.YT && window.YT.Player) { create(); return; }
        const previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
            if (typeof previous === 'function') previous();
            create();
        };
        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.addEventListener('error', fail, {once: true});
            document.head.append(script);
        }
    }
    new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
        sync();
    }, {threshold: [0, .25]}).observe(figure);
    function afterLoad() {
        const start = () => { loaded = true; sync(); };
        if ('requestIdleCallback' in window) window.requestIdleCallback(start, {timeout: 2000});
        else setTimeout(start, 0);
    }
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, {once: true});
    document.addEventListener('studio:motion-change', sync);
    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', sync);
    if (connection && connection.addEventListener) connection.addEventListener('change', sync);
}());
